export default {
  common: {
    cancel: "Annulla",
    close: "Chiudi",
    edit: "Modifica",
    archive: "Archivia",
    deactivate: "Disattivare",
    confirm: "Conferma",
    none: "Nessuno",
    unknown: "Sconosciuto",
    unavailable: "Non disponibile",
    system: "Sistema",
    yes: "Sì",
    no: "No",
    loading: "Caricamento",
    notRecorded: "Non registrato",
    notSelected: "Non selezionato",
    noReason: "Nessuna ragione.",
    unassigned: "Non assegnato",
    sensor: "Sensore",
    gateway: "Gateway",
    device: "Dispositivo di elemento",
    elementSensor: "Sensore di elementi",
    metric: "Metrico",
    email: "E-mail",
    messages: "Messaggi",
    needed: "Necessità",
    ready: "Pronto",
    noValue: "Nessun valore",
    tracked: "Tracciato",
    select: "Seleziona",
    resolved: "risolto",
    channels: "canali",
    staff: "personale",
    emails: "e-mail",
    until: "fino a quando",
    model: "Modello",
    location: "Luogo",
    status: "Stato",
    notes: "Note",
    name: "Nome",
    description: "Descrizione",
    serialNumber: "Numero di serie",
    installLocation: "Installare la posizione",
    lastSeen: "Ultimo accesso",
    latestReading: "Ultima lettura",
    maintenance: "Manutenzione",
    enabled: "Abilitato",
    disabled: "Disabilitato",
    immediate: "Immediato",
    minutes: "{count} minuti",
    minute: "{count} minuto",
    level: "Livello {level}",
    and: "E",
    countSensors: "Sensori {count}",
    countSensor: "Sensore {count}",
    countSelectedSensors: "{count} sensori selezionati",
    countSelectedSensor: "Sensore selezionato {count}",
    breachPoint: "{count} punto di superamento nell’intervallo selezionato.",
    breachPoints: "{count} punti di superamento nell’intervallo selezionato.",
    resultReadings: "{count} letture",
    resultReading: "{count} lettura",
    ending: "finale {suffix}",
  },
  enum: {
    area: {
      multi_purpose: "Multiuso",
      restroom: "Stanza da bagno",
      kitchen: "Cucina",
      plant_room: "Sala macchine",
      accommodation: "Alloggio",
      outdoor: "All'aperto",
      wellness: "Benessere",
      pool_spa: "Piscina / spa",
      gym: "Palestra",
      custom: "Personalizzato",
      general_building: "Edificio generale",
      restrooms: "Ripostiglio",
      kitchens: "Cucine",
      boiler_plant_rooms: "Boiler / sale per piante",
      residence_hotel_rooms: "Residence / camere",
    },
    icon: {
      building: "Edilizia",
      restroom: "Stanza da bagno",
      utensils: "Utensili",
      settings: "Impostazioni",
      bed: "Letto",
      tree: "Albero",
      pool: "Piscina",
      dumbbell: "Manubrio di bloccaggio",
      shield: "Scudo",
      custom: "Personalizzato",
    },
    colour: {
      emerald: "Smeraldo",
      blue: "Blu blu",
      amber: "Ambra",
      purple: "Viola",
      gold: "Oro",
      green: "Verde",
      slate: "Slate.",
    },
    status: {
      active: "Attivo",
      inactive: "Inattivo",
      archived: "Archiviato",
      online: "Online Online",
      offline: "Linea offline",
      maintenance: "Manutenzione",
      open: "Attivo",
      acknowledged: "Riconosciuto",
      resolved: "Risolto",
      suppressed: "Suppresse",
      draft: "Bozza",
      adopted: "Adozione da parte del Parlamento europeo",
      provisioning: "Disposizioni",
      pending_activation: "Attivazione dei pagamenti",
      failed: "Non riuscito",
      normal: "Normale",
      warning: "Avvertenza",
      critical: "Critico",
      info: "Informazioni",
      unknown: "Sconosciuto",
      compliant: "Conforme",
      attention: "Necessità di attenzione",
      not_started: "Non iniziato",
      scheduled: "Programmato",
      retired: "Ritiro",
      disabled: "Disabilitato",
    },
    metric: {
      temperature: "Temperatura",
      humidity: "Umidità",
      battery: "Batteria",
      signal: "Segnale",
      gateway_online: "Gateway online",
      sensor_online: "Sensore online",
      co2: "CO2",
      pm2_5: "PM2.5",
      pm10: "PM10",
      fill_level: "Livello di riempimento",
      rainfall: "Cascata di pioggia",
      wind_speed: "Velocità del vento",
      water_leak: "Trasmissione di acqua",
      door_state: "Stato della porta",
      vape_detected: "Rilevamento del vassoio",
      fall_detected: "Rilevamento di caduta",
      presence: "Presenza",
      odor_level: "Livello di oltraggio",
      location: "Luogo",
      movement: "Movimento",
      compound: "Condizioni totali",
    },
    condition: {
      below: "Di seguito",
      above: "sopra",
      equals: "uguale",
      not_reporting: "non segnalazione",
    },
    severity: { info: "Informazioni", warning: "Avvertenza", critical: "Critico" },
    health: {
      normal: "Normale",
      warning: "Avvertenza",
      critical: "Critico",
      offline: "Linea offline",
    },
    action: {
      triggered: "Attivato",
      acknowledged: "Riconosciuto",
      assigned: "Assegnato",
      resolved: "Risolto",
      auto_resolved: "Autorisolto",
      suppressed: "Suppresse",
      maintenance_suppressed: "Suppresso durante la manutenzione",
      notification_sent: "Notifica inviata",
      notification_failed: "Notifica fallita",
      escalation_sent: "Escalation inviato",
    },
    reading: {
      leak: "Perdita di perdita",
      dry: "Asciugatura",
      open: "Apri",
      closed: "Chiuso",
      detected: "Detetto",
      clear: "Cancella",
      occupied: "Occupazione",
      vacant: "Vacante",
      elevated: "Elevato",
      normal: "Normale",
    },
    connection: {
      ethernet: "Ethernet",
      wifi: "Wi-fi",
      cellular: "Cellulare",
      lorawan: "Condividi su Facebook",
    },
    hardware: { gateway: "Gateway", sensor: "Sensore" },
  },
  range: {
    last24Hours: "Ultime 24 ore",
    last7Days: "Ultimi 7 giorni",
    lastMonth: "Il mese scorso",
    lastYear: "Ultimo anno",
    short24h: "24 ore",
    short7d: "7.",
    short1m: "1",
    short1y: "1",
  },
  errors: {
    invalidGatewayEui: "Gateway EUI deve essere 16 caratteri esadecimali.",
    gatewayAlreadyAdopted: "Questo gateway è già adottato da questo club.",
    chirpstackGatewayExists:
      "Gateway esiste già a ChirpStack; collegandolo a questo club.",
    zoneKeyExists: "Una zona con questa chiave esiste già.",
    deviceKeyExists: "Esiste già un dispositivo con questa chiave.",
    invalidDevEui: "DevEUI deve essere 16 caratteri esadecimali.",
    invalidJoinEui: "JoinEUI/AppEUI deve essere 16 caratteri esadecimali.",
    invalidAppKey: "AppKey deve essere 32 caratteri esadecimali.",
    missingLorawanCredentials:
      "DevEUI, JoinEUI/AppEUI, e AppKey sono necessari.",
    thresholdRequired: "Inserisci un valore di soglia.",
    notReportingRequired: "Inserisci il numero di minuti senza segnalazione.",
    ruleNameRequired: "Inserisci un nome di regola.",
    scopeSensorRequired: "Selezionare un sensore.",
    scopeZoneRequired: "Seleziona una zona.",
    scopeGatewayRequired: "Selezionare un gateway.",
    scopeGroupRequired: "Selezionare un gruppo di sensori.",
    recipientRequired:
      "Selezionare almeno un destinatario del personale per Privana Messaggi.",
    clubCodeMissing: "Il codice del club non è stato trovato nel percorso corrente.",
    overviewLoad: "Non poteva caricare Privana dati di monitoraggio degli elementi.",
    zoneLoad: "Incapace di caricare i dettagli della zona.",
    graphLoad: "Non è in grado di caricare la gamma dei grafici.",
    alertRulesLoad: "Incapace di caricare le regole di allarme.",
    alertCentreLoad: "Incapace di caricare il centro di allarme.",
    saveRule: "Incapace di salvare la regola dell'avviso.",
    deactivateRule: "Incapace di disattivare la regola.",
    saveZone: "Incapace di salvare la zona Element.",
    saveDevice: "Incapace di salvare il dispositivo Element.",
    adoptHardware: "Incapace di adottare l'hardware.",
    updateHardware: "Non è possibile aggiornare l'hardware.",
    assignSensor: "Incapace di assegnare il sensore.",
    unassignSensor: "Incapace di ignorare il sensore.",
    archiveZone: "Incapace di archivio zona.",
    deactivateDevice: "Incapace di disattivare il dispositivo.",
    refreshGateway: "Incapace di aggiornare lo stato del gateway in questo momento.",
    gatewaySyncFailed: "La sincronizzazione del gateway è fallita",
    startMaintenance: "Incapace di avviare la manutenzione.",
    endMaintenance: "Incapace di terminare la manutenzione.",
    actionAlert: "Incapace di {action} allerta.",
    cameraDenied:
      "Il permesso della macchina fotografica è stato negato. Consentire l'accesso della fotocamera o incollare il testo QR invece.",
    cameraMissing: "Nessuna fotocamera è stata trovata su questo dispositivo. Incolla il testo QR invece.",
    cameraStart:
      "Scanner non ha iniziato. Consentire l'accesso della fotocamera, chiudere altre applicazioni della fotocamera, o incollare il testo QR invece.",
    cameraUnavailable:
      "L'accesso alla fotocamera non è disponibile in questo contesto del browser. Utilizzare la pasta fallback o aprire Privana su HTTPS.",
    scannerRegion: "Il contenitore dello scanner non è stato reso prima dell'inizio della fotocamera.",
    invalidPairing:
      "Questo collegamento di accoppiamento non è valido. Generare un nuovo link dal modal desktop.",
    pairingConnect: "Non è possibile connettersi. Mantenere questa pagina aperta e riprovare.",
    photoDecode:
      "Non poteva decodificare un codice QR da quella foto. Riempire la cornice con il codice QR e riprovare.",
    connecting: "Privana è ancora in collegamento. Riprova in un momento.",
  },
  dashboard: {
    loadingLabel: "Caricamento del cruscotto Privana Element",
    filterZone: "Filtra per zona",
    filterZonePlaceholder: "Filtra per Zona",
    allZones: "Tutte le zone",
    selectRange: "Seleziona l'intervallo di tempo",
    addZone: "Aggiungi zona",
    alertCentre: "Centro avvisi",
    manageAlerts: "Gestione di avvisi",
    refresh: "Aggiorna",
    gatewayRefreshed: "Stato del gateway rinfrescato",
    gatewayRefreshedHelp: "L'ultimo stato del gateway ChirpStack è stato sincronizzato.",
    lastRefreshed: "Ultimo aggiornamento {date}",
    attention: "Privana Element ha bisogno di attenzione",
    retry: "Riprova",
    kpiLabel: "Privana Element KPI card",
    systemHealth: "Salute del sistema",
    weightedEstate: "Punteggio immobiliare ponderato",
    activeAlerts: "Avvisi attivi",
    openAcknowledged: "Aperto o riconosciuto",
    sensorsOnline: "Sensori online",
    basedLastSeen: "Sulla base dell'ultimo visto",
    zonesMonitored: "Zone monitorate",
    configuredZones: "Zone di Elemento configurate",
    complianceStatus: "Stato di conformità",
    fromCompliance: "Dai registri di conformità",
    maintenanceDue: "Manutenzione dovuta",
    dueNext14: "Due nei prossimi 14 giorni",
    noZones: "Nessuna zona Element configurata",
    noZonesHelp:
      "Crea zone Element per questo club per iniziare a monitorare General Building, Ristagni, Cucine, Plant Rooms, Residence & Hotel Rooms e aree esterne.",
    monitoredZones: "Zone monitorate",
    monitoredZonesHelp:
      "Sicurezza delle imprese, ambiente, igiene, catena a freddo e telemetria esterna.",
  },
  zone: {
    unnamed: "Zona non nominata",
    monitoredArea: "Area monitorata",
    sensors: "Sensori",
    online: "Online Online",
    alerts: "Avvisi",
    assignedWaiting: "I sensori sono assegnati; in attesa di prime letture.",
    setupReady: "Setup pronto — assegnare un sensore adottato a questa zona.",
    view: "Visualizza zona",
    editLabel: "Modifica di {name}",
    archiveLabel: "Archivio {name}",
    detail: "Zona Dettaglio",
    sensorDetail: "Dettaglio del sensore",
    expandedGraph: "Grafico espanso",
    loading: "Zona di carico...",
    back: "Indietro",
    backToSensor: "Torna al sensore",
    assignedToZone: "Assegnato a zona",
    latestMetricPoints: "Ultimi punti metrici",
    manage: "Gestisci la zona",
    edit: "Modifica della zona",
    assignSensor: "Sensore di assegnazione",
    noCatalogue: "Nessun modello di catalogo selezionato",
    gatewayNetwork: "Gateway / Rete",
    noSensors: "Nessun sensore assegnato",
    noSensorsHelp:
      "Assegnare un sensore non firmato adottato per iniziare a raccogliere la telemetria di Elemento vivo per questa zona.",
    latestReadings: "Le ultime letture",
    noReadings: "Nessuna lettura per questa zona",
    noReadingsHelp: "Le letture appariranno una volta che i dispositivi post telemetria.",
    create: "Creare Zone",
    formHelp:
      "Configurare come questa area Element appare nel cruscotto di monitoraggio attivo.",
    name: "Nome della zona",
    areaType: "Tipo di area",
    iconKey: "Chiave Icon",
    colourKey: "Colore chiave",
    descriptionPlaceholder: "Che cosa copre questa zona...",
    exampleName: "Edificio generale",
    save: "Salvare la zona",
    archive: "Zona dell'archivio",
    archivePrompt:
      "Archiviare questa zona? Le letture e gli avvisi esistenti saranno conservati.",
    archiveAction: "Archivio Zona",
    archived: "Zone archiviate",
    archivedHelp: "Sono state conservate letture e avvisi esistenti.",
    created: "Zone create",
    updated: "Zone aggiornate",
    refreshed: "Privana Zone Element sono state rinfrescate.",
    saveFailed: "Salvataggio delle zone guasto",
    archiveFailed: "Archivio fallito",
  },
  readings: {
    temperatureShort: "Tempi",
    humidity: "Umidità",
    battery: "Batteria",
    noNumericTitle: "Nessuna storia numerica {metric}",
    noNumericHelp:
      "Una linea di tendenza apparirà una volta che la telemetria numerica viene ricevuta per questa metrica.",
    chartLabel: "Grafico della tendenza {metric}",
    expandLabel: "Espandere il grafico {metric}",
    lastUpdated: "Ultimo aggiornamento {date}",
    safeRange: "Gamma sicura {min} – {max}",
    noSafeRange: "Nessuna soglia configurata per una banda sicura.",
    latestValue: "Valore più recente",
    selectedRange: "intervallo selezionato",
    loadingRange: "Caricamento dell'intervallo selezionato...",
    loading: "Caricamento",
    sensorGraphs: "Grafi del sensore",
    liveTelemetry: "Telemetria Live Element",
    defaultRange: "Campo di default: {range}",
    noHistory: "Nessuna lettura storica ancora",
    noHistoryHelp:
      "Le schede del grafico appariranno come questa temperatura dei messaggi del sensore, umidità, batteria o altre metriche dell'elemento.",
    noThreshold: "Nessuna soglia configurata",
    breach: "Violazione: {reason}",
    thresholdLimit: "Limite di soglia: {limit}",
    severity: "Gravità: {severity}",
    threshold: "Soglia: {name}",
  },
  panels: {
    activeAlerts: "Avvisi attivi",
    noActiveAlerts: "Nessun avviso attivo",
    noActiveAlertsHelp:
      "Gli avvisi Open Element appariranno qui con le azioni di riconoscimento e risoluzione.",
    acknowledge: "Riconoscimento",
    resolve: "Risolvere",
    reviewTelemetry: "Rivedere la telemetria del dispositivo.",
    unassignedZone: "Zona non firmata",
    quickInsights: "Insights rapide",
    complianceSummary: "Riepilogo della conformità",
    currentStatus: "Situazione attuale",
    latest: "Ultimi: {title} · {date}",
    complianceReport: "Rapporto di conformità",
    noCompliance: "Nessun report di conformità generato",
    noComplianceHelp:
      "I registri di conformità degli elementi riassumeranno le prove generate di sicurezza, igiene e monitoraggio una volta abilitata la segnalazione.",
    recentActivity: "Attività recenti",
    telemetry: "Telemetria degli elementi",
    noActivity: "Nessuna attività recente",
    noActivityHelp:
      "Gli avvisi, le letture e le azioni di avviso popolano questo feed come dispositivi inviano la telemetria.",
    trend: "24h Trend Panoramica",
    readingCounts: "La lettura conta per ora",
    noTrend: "Nessuna lettura nelle 24 ore per il momento",
    noTrendHelp:
      "Le barre di tendenza compariranno dopo che la telemetria live è ingerita dai dispositivi Milesight.",
  },
  insight: {
    hardwareReadyTitle: "Adozione hardware pronta",
    hardwareReadyDetail: "Adottare l'hardware una volta, quindi assegnare i sensori alle zone.",
    offlineOne: "{count} dispositivo offline",
    offlineMany: "{count} dispositivi offline",
    offlineDetail: "Recensione degli ultimi timestamp e connettività LoRaWAN.",
    alertsOne: "{count} avviso attivo",
    alertsMany: "{count} avvisi attivi",
    alertsDetail: "Riconoscere o risolvere gli avvisi dal pannello Active Alerts.",
    zonesOne: "{count} zona in attesa di sensori",
    zonesMany: "{count} zone in attesa di sensori",
    zonesDetail: "Assign ha adottato sensori non firmati per le zone monitorate.",
    awaitingTitle: "Risveglio delle prime letture",
    awaitingDetail:
      "Il punto finale di ingestione è pronto per Milesight API /MQTT handoff.",
    sustainabilityTitle: "Punteggio di sostenibilità {score}",
    sustainabilityDetail: "Ultimi calcoli sulla sostenibilità degli elementi.",
    stableTitle: "Elemento immobiliare stabile",
    stableDetail: "Nessuna eccezione attiva rilevata nelle zone monitorate.",
  },
  activity: {
    readingTitle: "{metric} lettura ricevuta",
    actionTitle: "{action} registrati",
  },
  alert: {
    fallbackTitle: "Allerta degli elementi",
    unknownDevice: "Dispositivo sconosciuto",
    assignedTo: "Assegnata a {name}",
    acknowledgedBy: "Riconosciuto da {name}",
    notAcknowledged: "Non riconosciuto",
    takeOwnership: "Assumere la proprietà",
    auditTrail: "Registro di audit",
    auditDescription: "{title} eventi del ciclo di vita.",
    search: "Avviso di ricerca",
    exportSoon: "Esportazione CSV (a breve)",
    exportSoonTitle: "CSV esportazione in arrivo",
    exportSoonHelp:
      "L'esportazione è in arrivo — TODO: Centro di allarme CSV esportazione.",
    loading: "Caricamento di avvisi...",
    centreHelp:
      "Attiva, riconosciuta, risolta, soppressa, escalata Privana Element avvisi con contesto di proprietà operativa.",
    historyLoadFailed: "La storia dell'allarme non è riuscita a caricare",
    actionComplete: "Allarme {action} completo",
    ownershipComment: "Preso da Alert Centre",
    manageTitle: "Gestione di avvisi",
    manageHelp:
      "Creare, modificare, disattivare e rivedere le regole di soglia di allarme Privana Element.",
    manageGroups: "Gestione dei gruppi di sensori",
    createRule: "Creare la regola dell'avviso",
    existingRules: "Regole di allarme esistenti",
    loadingRules: "Regole di carico...",
    noRules: "Nessuna regola di avviso configurata",
    noRulesHelp:
      "Creare una batteria, umidità, temperatura, segnale, stato online o regola di non-reporting per avviare il monitoraggio della soglia.",
    recipients: "Recipienti: {recipients}",
    duration: "Durata: {duration}",
    cooldown: "Raffreddamento: {duration}",
    channels: "Canali: {channels}",
    autoResolve: "Auto-risolvere: {value}",
    notifyResolve: "Informare sulla risoluzione: {value}",
    escalations: "Escalation: {value}",
    noStaff: "Nessun personale selezionato",
    recentHistory: "Storia attivata/risolta",
    sendTest: "Avviso di prova",
    testSent: "Allarme TEST inviato",
    testSentHelp: "La notifica di prova è stata registrata ed etichettata come TEST.",
    deactivated: "Disattivare la regola di allarme",
    deactivateFailed: "Disattivare fallito",
    saved: "Regola di avviso salvata",
    savedHelp: "Sono state aggiornate Privana soglie di allarme Element.",
    saveFailed: "Regola di allerta salvare fallito",
    rulesLoadFailed: "Le regole di allarme non sono riuscite a caricare",
    status: {
      active: "Attivo",
      acknowledged: "Riconosciuto",
      resolved: "Risolto",
      suppressed: "Suppresse",
    },
    rule: {
      edit: "Modificare la regola dell'avviso",
      create: "Creare la regola dell'avviso",
      help: "Configurare una condizione o richiedere più condizioni per rimanere allineare per tutta la durata.",
      save: "Salva la regola",
      name: "Nome della regola",
      namePlaceholder: "Batteria inferiore al 10%",
      severity: "Severità",
      scope: "Ambito",
      allSensors: "Tutti i sensori",
      specificSensor: "Sensore specifico",
      specificZone: "Zona specifica",
      specificGateway: "gateway specifico",
      sensorGroupScope: "Gruppo sensore / sensori multipli",
      sensorGroup: "Gruppo sensore",
      selectGroup: "Selezionare il gruppo sensore",
      noGroups:
        "Nessun gruppo di sensori configurato. Crea uno da Gestisci gruppi di sensori.",
      durationBefore: "Durata prima di avviare",
      customMinutes: "Minuti personalizzati",
      repeatInterval: "Freno / intervallo di ripetizione",
      ruleCap: "Regolare il tappo di notifica giornaliero",
      deviceCap: "Tappo di notifica giornaliero del dispositivo",
      cycleCap: "Tappo di notifica del ciclo di lavoro",
      conditions: "Condizioni",
      conditionsHelp:
        "Tutte le condizioni devono essere vere. Aggiungere l'umidità + righe di temperatura per le regole del composto.",
      addCondition: "Aggiungi condizione",
      remove: "Rimuovi",
      minutesNotReporting: "Minuti non segnalati",
      threshold: "Soglia",
      escalationPath: "Percorso di escalation",
      escalationHelp:
        "Livello 1 utilizza i destinatari iniziali. Livelli 2 e 3 inviano una volta quando non risolti oltre i minuti configurati.",
      escalateAfter: "Escalate dopo pochi minuti",
      fallbackEmails: "E-mail di Fallback",
      staffRecipients: "Destinatari del personale",
      staffRecipientsHelp:
        "Privana Le notifiche dei messaggi richiedono utenti selezionati del personale. Email utilizza anche i loro indirizzi e-mail del personale.",
      messagesNotification: "Privana Messaggi di notifica",
      autoResolveNormal: "Auto-risolvere quando normale",
      notifyOnResolve: "Informare sulla risoluzione",
      manualEmails: "E-mail del destinatario manuale (avanzate/fallback)",
      selectedRequired:
        "Selezionare almeno un destinatario del personale per Privana Messaggi.",
      scopeSensor: "Sensore: {name}",
      scopeZone: "Zona: {name}",
      scopeGateway: "Gateway: {name}",
      scopeGroup: "Gruppo sensore: {name}",
      notReporting: "{metric} non segnalazione per {minutes} minuti",
      comparison: "{metric} {condition} {value}",
      escalationSummary:
        "L {level} dopo {minutes} m ({staff} personale, {emails} email, {channels} )",
    },
    groups: {
      title: "Gestione dei gruppi di sensori",
      help: "Crea gruppi di sensori Element separati da zone per l'avviso di destinazione.",
      name: "Nome del gruppo",
      namePlaceholder: "Tutti i congelatori",
      saved: "Gruppo sensore salvato",
      archived: "Gruppo di sensori archiviato",
      save: "Gruppo di risparmio",
      create: "Crea gruppo",
    },
  },
  hardware: {
    adoptedTitle: "Hardware adottato",
    adoptedHelp: "Gateway e sensori registrati a questo club.",
    manage: "Gestione hardware",
    adopting: "Adottare...",
    adopt: "Adottare Hardware",
    totalSensors: "Sensori totali adottati",
    totalGateways: "Totale gateways",
    unassignedSensors: "Sensori non firmati",
    offlinePending: "Dispositivi Offline/Pending",
    overview: "Panoramica",
    gateways: "Gateways",
    sensors: "Sensori",
    adoptTab: "Adottare l'hardware",
    gatewaysAdopted: "Portali adottati",
    sensorsAdopted: "Sensori adottati",
    pendingActivation: "Attivazione dei pagamenti",
    onlineDevices: "Dispositivi online",
    overviewTitle: "Adottare l'hardware una volta, quindi assegnare i sensori alle zone.",
    overviewHelp:
      "I gateway rimangono come infrastruttura a livello di club. I sensori rimangono in inventario fino ad assegnare ad una zona monitorata.",
    overviewAssignHelp:
      "I sensori sono assegnati a zone dall'interno di ogni zona. Utilizzare \"Assign Sensor\" all'interno di una zona per distribuire hardware.",
    noGateways: "Nessuna porta d'accesso adottata",
    noGatewaysHelp:
      "Adottare un gateway per registrare l'infrastruttura di rete a livello di club.",
    noSensors: "Non sono stati adottati sensori",
    noSensorsHelp: "Adottare i sensori, quindi assegnare i sensori disponibili alle zone.",
    gatewayModelMissing: "Modello Gateway non selezionato",
    sensorModelMissing: "Modello sensore non selezionato",
    gatewayEui: "Gateway EUI",
    sensorsUsingGateway: "Sensori che utilizzano gateway",
    connectionType: "Tipo di collegamento",
    edit: "Modifica",
    endMaintenance: "Manutenzione finale",
    startMaintenance: "Inserire nella manutenzione",
    editHardware: "Modifica di {kind}",
    editHelp: "Aggiornamento dei dettagli hardware adottati.",
    provisioningStatus: "Stato di previsione",
    protectedIdentity: "Identita' ChirpStack protetta.",
    save: "Salva l'hardware",
    updated: "Aggiornamento hardware",
    updatedHelp: "Sono stati salvati i dettagli hardware adottati.",
    updateFailed: "Aggiornamento hardware fallito",
    adopted: "Adozione da parte dell'hardware",
    adoptedSuccess: "Il dispositivo è ora registrato a questo club.",
    adoptionFailed: "L'adozione fallita",
    deactivated: "Dispositivo disattivato",
    deactivatedHelp: "Sono state conservate letture e avvisi storici.",
    deactivateFailed: "Disattivare fallito",
    deactivateTitle: "Disattivare il dispositivo",
    deactivatePrompt:
      "Riattivare questo dispositivo? Verranno conservate letture e avvisi storici.",
    deactivateAction: "Disattivare il dispositivo",
    assignTitle: "Sensore di assegnazione",
    assignHelp: "Selezionare un sensore non firmato adottato per {zone} .",
    thisZone: "questa zona",
    unassignedSensor: "Sensore non assegnato",
    noModel: "Nessun modello",
    noAssignable: "Nessun sensore assegnabile",
    noAssignableHelp: "Adottare prima un nuovo sensore, quindi assegnarlo a questa zona.",
    adoptInstead: "Adottare il nuovo sensore invece",
    assign: "Sensore di assegnazione",
    assigned: "Sensore assegnato",
    assignedHelp: "La lista dei dispositivi {zone} è stata aggiornata.",
    assignFailed: "Assegnazione fallita",
    unassignedToast: "Sensore non firmato",
    unassignedHelp: "Il sensore è tornato all'inventario non firmato.",
    unassignFailed: "Una firma fallita",
    editAssignment: "Modifica dell'assegnazione",
    unassignFromZone: "Unassign da zona",
    actionsLabel: "Azioni aperte per {name}",
    maintenanceTitle: "Inserire nella manutenzione",
    maintenanceHelp:
      "Premere le notifiche di avviso per questo dispositivo o gateway mentre le letture continuano a essere registrate.",
    maintenanceReason: "Motivo di manutenzione",
    maintenancePlaceholder:
      "Rimozione di batterie, trasferimento di gateway, calibrazione...",
    optionalEnd: "Data finale opzionale/ora",
    startMaintenanceAction: "Avviare la manutenzione",
    maintenanceEnabled: "Modalità di manutenzione abilitata",
    maintenanceEnabledHelp: "{device} notifiche saranno soppresse.",
    maintenanceEnded: "Manutenzione finita",
    maintenanceEndedHelp: "{device} notifiche di avviso ripresentate.",
    maintenanceFailed: "Manutenzione fallita",
    adoption: {
      step: "Passo 1: Scegli il tipo di hardware",
      regionResolved: "Regione LoRaWAN: {region} , risolta da {source} .",
      regionClubCountry: "paese del club {country}",
      regionMissing:
        "La regione di LoRaWAN non poteva essere risolta dall'indirizzo di questo club. Si prega di completare l'indirizzo del club prima di adottare l'hardware LoRaWAN.",
      gatewayName: "Nome del gateway",
      gatewayNamePlaceholder: "Portale principale del club",
      gatewayModel: "Modello del gateway/catalogo",
      serialOptional: "Numero di serie (opzionale)",
      serialPlaceholder: "Numero di serie Milesight",
      locationPlaceholder: "Scaffale della camera",
      sensorName: "Nome del sensore",
      sensorNamePlaceholder: "Sensore di perdita dei locali",
      sensorModel: "Modello sensore/catalogo",
      preferredGateway: "gateway/network preferiti",
      pairingCode: "Codice di coppia / codice QR / numero di serie",
      pairingPlaceholder: "Riferimento opzionale seriale o QR",
      sensorLocationPlaceholder: "Sotto lavello 2",
      notesPlaceholder: "Note di installazione opzionali",
      gatewayHelp:
        "I gateway richiedono un gateway EUI per ChirpStack. Il numero di serie è facoltativo e mantenuto separato dal gateway EUI.",
      scanQr: "Scansione del codice QR",
      scanQrHelp:
        "Scansione del codice QR dall'etichetta del sensore o dall'imballaggio. Privana estrarrà automaticamente i dettagli LoRaWAN.",
      scanCamera: "Scansione con la fotocamera",
      scanPhone: "Scansione con il telefono",
      scanPhoneHelp:
        "Aprire questo QR di accoppiamento su un telefono accanto al sensore. Lo scanner mobile invierà DevEUI, JoinEUI/AppEUI, AppKey e ha rilevato il modello di nuovo a questa sessione desktop.",
      waitingPhone: "Aspettando la scansione del telefono...",
      newQr: "Nuovo QR di accoppiamento",
      pasteQr: "Incolla il testo QR qui se la scansione della fotocamera non è disponibile",
      pasteQrLabel: "Incolla il testo QR",
      parseQr: "Codice QR Parse",
      stopCamera: "Fermare la fotocamera",
      credentials: "credenziali LoRaWAN",
      appKeyCaptured: "AppKey catturato {ending} .",
      appKeyMissing: "AppKey non e' ancora stato catturato.",
      devEui: "Lo sviluppo",
      joinEui: "Unisciti all’EUI/AppEUI",
      serialNotFound: "Non ancora trovato",
      nextStep:
        "Prossimo passo: Trovare JoinEUI/AppEUI e AppKey in Milesight ToolBox o il foglio di provisioning del dispositivo.",
      manualTitle: "Dettagli LoRaWAN manuali — Avanzato",
      manualHelp: "L'ingresso manuale è solo per gli installatori tecnici.",
      appKeyEncrypted: "Conservato crittografato dopo l'adozione",
      milesightHelp:
        "Milesight default AppKey è comunemente il DevEUI ripetuto due volte. Override se il foglio di provisioning dice diversamente.",
      qrReady: "{source} parsed. LoRaWAN dettagli sono pronti per l'adozione.",
      qrSerialOnly:
        "QR trovato, ma contiene solo il numero di serie. Le chiavi LoRaWAN sono ancora richieste.",
      qrMissingKeys: "QR trovato, ma JoinEUI/AppKey sono ancora necessari.",
      qrNoCredentials: "{source} trovato ma nessuna credenziali LoRaWAN trovata.",
      phoneSource: "Controllo telefonico",
      phoneModel: "Scansione del telefono ricevuta. Modello del sensore rilevato: {model}",
      phoneUpdated: "Controllo telefonico ricevuto. Campi desktop aggiornati.",
      phoneUnavailable:
        "Non è possibile collegare l'accoppiamento del telefono. Incolla il testo QR invece.",
      requestingCamera: "Richiedo il permesso della telecamera...",
      cameraActive:
        "Macchina fotografica attiva — riempire la scatola con il codice QR. Toccare l'anteprima per concentrarsi.",
      scanNoCredentials:
        "Il QR ha trovato ma non ha trovato alcuna credenziali LoRaWAN. Provare la scansione di nuovo o incollare il testo QR invece.",
    },
  },
  device: {
    edit: "Modifica del dispositivo",
    add: "Aggiungi dispositivo",
    formHelp:
      "Selezionare il modello di catalogo e gestire solo i dettagli operativi mostrati al personale.",
    zone: "Zona",
    typeModel: "Tipo di dispositivo / modello di catalogo",
    name: "Nome del dispositivo",
    namePlaceholder: "Monitor frigo cucina",
    locationPlaceholder: "parete nord",
    maintenanceDue: "Manutenzione data",
    save: "Salvare il dispositivo",
    added: "Dispositivo aggiunto",
    updated: "Dispositivo aggiornato",
    refreshed: "Le assegnazioni dei dispositivi di zona sono state aggiornate.",
    saveFailed: "Salvataggio del dispositivo guasto",
  },
  pairing: {
    connecting: "Collegamento a Privana...",
    title: "Codice QR del sensore di scansione",
    subtitle:
      "Privana invierà i dettagli LoRaWAN al modo di adozione desktop.",
    boxHelp: "Riempire la scatola con il codice QR. Toccare per concentrarsi.",
    standby: "Fotocamera scanner standby",
    uploadFallback: "Caricamento/Take Photo Fallback",
    upload: "Carica/Prendere la foto",
    toolboxHelp:
      "Trovare JoinEUI/AppEUI e AppKey in Milesight ToolBox o il foglio di provisioning del dispositivo.",
    pasteFallback: "Incolla il testo QR fallback",
    pastePlaceholder: "Incolla il testo QR se la scansione della fotocamera non è disponibile",
    stopCamera: "Fermare la fotocamera",
    startCamera: "Avviare lo scanner della fotocamera",
    send: "Invia",
    qrSource: "Codice QR",
    qrReady: "{source} parsed. I dettagli LoRaWAN sono pronti.",
    qrSerialOnly:
      "QR trovato, ma contiene solo il numero di serie. Le chiavi LoRaWAN sono ancora richieste.",
    qrMissingKeys: "QR trovato, ma JoinEUI/AppKey sono ancora necessari.",
    qrNoCredentials:
      "{source} trovati ma non sono state trovate credenziali LoRaWAN. Prova a scansionare di nuovo, scattare una foto, o incollare il testo QR.",
    sentReady: "LoRaWAN dettagli inviati al desktop adozione modal.",
    sentPartial: "{status} Dettagli inviati al desktop modal.",
    requestingCamera: "Richiedo il permesso della telecamera...",
    cameraActive:
      "Macchina fotografica attiva — riempire la scatola con il codice QR. Toccare l'anteprima per concentrarsi.",
    connectedReopen: "Riaprire l'ultimo scanner della fotocamera...",
    connectedReady: "Collegato. Tocca Avviare lo scanner della fotocamera o Caricare/Prendere la foto.",
    decoding: "Decoding QR da foto...",
    diagnostics: "Diagnostica QR",
    diagnosticsMediaDevices: "navigator.mediaDispositivi disponibili?",
    diagnosticsGetUserMedia: "Accesso ai media della fotocamera disponibile?",
    diagnosticsSecureContext: "Il contesto sicuro del browser?",
    diagnosticsLocation: "Luogo della pagina",
    diagnosticsLoaded: "Lo scanner QR caricato con successo?",
    diagnosticsStartError: "Errore di avvio dello scanner QR",
    warnings: {
      empty: "Incollare o scansionare prima un codice QR.",
      serialOnly:
        "QR trovato, ma contiene solo il numero di serie. Le chiavi LoRaWAN sono ancora richieste.",
      missingKeys: "QR trovato, ma JoinEUI/AppKey sono ancora necessari.",
      partial:
        "Alcuni dettagli LoRaWAN sono stati trovati, ma JoinEUI/AppEUI e AppKey sono entrambi necessari.",
      none: "Non sono state trovate credenziali LoRaWAN. Prova a incollare il testo QR completo o utilizzare i dettagli Manual LoRaWAN.",
      toolbox:
        "Trovare JoinEUI/AppEUI e AppKey in Milesight ToolBox o il foglio di provisioning del dispositivo.",
      invalidHex: "{field} deve essere {count} caratteri esagonali.",
    },
  },
};
